import React, {useContext, useEffect} from 'react'
import crumbsContext from 'contexts/crumbs'
import { Link } from 'react-router-dom'
export default function ClosePopupBtn(props) {
    const {close} = props
    return (
        <div className='closePopupBtn flex center' onClick={() => close()}>
            Fermer
        </div>
    )
}
